import React from 'react';
import Option from './Option';
import { TicketPriority } from '../../../../../../../../constants/Types';

interface PriorityListProps {
  slaNames: string[],
  priority: TicketPriority,
  update,
}

const PriorityList = ({
  slaNames, priority, update,
}: PriorityListProps) => <>
    {slaNames.map((text: string, itemIndex: number) => <Option
      key={`priority_option_${text}`}
      text={`P${itemIndex + 1} - ${text}`}
      selected={priority === itemIndex}
      onPress={() => update(itemIndex)}
    />)}
  </>;

export default PriorityList;
